// A hozzáférés kliensoldali értelmezése (v177, docs/TAGSAG_BELEPES_TERV.md). A DÖNTÉST a szerver és a Firestore-szabály hozza; a kliens csak
// a saját `access` dokumentumát olvassa, hogy a megfelelő képernyőt mutassa (a felfüggesztett / lejárt tag ne lásson hibákat, hanem magyarázatot).
// Ugyanaz a logika, mint a functions/src/lib/auth.js `membershipBlocks` és a firestore.rules `tagsagTiltja()`.

/** A tagság (felfüggesztve / lejárt) tiltja-e a hozzáférést? Admint nem. */
export function tagsagTiltja(access, now = Date.now()) {
  if (!access || access.role === "admin") return false;
  if (access.membershipBlock === true) return true;
  const vu = access.membershipValidUntil;
  return typeof vu === "number" && now >= vu;
}

/** Aktív hozzáférés: az `active` igaz, és a tagság nem tiltja. */
export function hozzaferesAktiv(access, now = Date.now()) {
  return Boolean(access) && access.active === true && !tagsagTiltja(access, now);
}
